import { AfterViewInit, Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';

import { IDataset } from '../../models/dataset';
import { DatasetService } from '../../services/dataset.service';

/** Component for showing metadata about the plot data */
@Component({
    selector: 'sci-info-dialog',
    templateUrl: './info-dialog.component.html',
    styleUrls: [ '../../assets/dialog-style.css' ]
})
export class InfoDialogComponent implements OnInit {
    displayedColumns: string[] = [ 'key', 'value' ];
    dataSource;

    constructor( public dialogRef: MatDialogRef<InfoDialogComponent>, @Inject(MAT_DIALOG_DATA) public data ) {}

    ngOnInit() {
        this.dataSource = this.parseMeta( this.data.data );
    }

    /** given a dataset, get the metadata that we care about in a format that mat-table can handle */
    parseMeta( data: any ) {
        const returnVal = [];
        data.forEach( value => {
            const metadata = value.metadata;
            const newObj = {};
            newObj['name'] = value.name; // get the name of the dataset
            // parse all fields that aren't description, name, or exist
            for ( const key in metadata ) {
                if ( key !== 'description' && key !== 'name') {
                    if ( metadata[key]['exist'] !== false ) {
                        newObj[ key ] = [];
                        for ( const property in metadata[key] ) {
                            if ( typeof metadata[key][property] !== null && property !== 'exist' ) {
                                newObj[ key ].push({
                                    key: property,
                                    value: metadata[key][property]
                                });
                            }
                        }
                        // remove empty attributes
                        if ( newObj[ key ].length === 0 ) {
                            delete newObj[ key ];
                        }
                    }
                }
            }
            returnVal.push( newObj );
        });

        return returnVal;
    }

    /** returns whether a variable is an object */
    isObject = object => typeof object === 'object';

    /** converts and object to a html paragraph string */
    objectToString( object: object ) {
        // create a new line for each item
        // show the key in bold and the value next to it
        let returnString = '';
        for ( const key in object ) {
            if ( object.hasOwnProperty( key ) && key !== 'exist' ) {
                returnString += '<p> <strong> ' + key + '</strong>: ' + object[key] + '</p>';
            }
        }
        return returnString;
    }
}

@Component({
    selector: 'sci-info-dialog-button',
    template: `
        <button mat-icon-button (click)="openDialog()" matTooltip="Metadata">
            <mat-icon>info</mat-icon>
        </button>
    `
})
export class InfoDialogButtonComponent implements AfterViewInit {
    @Input() plotId: string;
    datasets: IDataset[] = [];

    constructor( public dialog: MatDialog, private _datasetService: DatasetService ) {}

    ngAfterViewInit() {
        this._datasetService.getPlotDatasets$( this.plotId ).subscribe(
            newDatasets => this.datasets = newDatasets.datasets
        );
    }

    /** open a dialog to display metadata for each available dataset */
    openDialog(): void {
        this.dialog.open( InfoDialogComponent, {
            minWidth: '400px',
            width: '50%',
            data: { data: this.datasets }
        });
    }
}
